import React, { useState, useEffect, useMemo } from 'react'
import moment from 'dayjs'
import { useTranslation } from "@/langs/useTranslation";
import DataTable from '../DataTable'
import TaskStatusBar from '../commons/TaskStatusBar';
import { ReactRender } from "../ReactRender";
import ScheduleTaskRange from '@/containers/Schedule/CreateTemplate/TaskCreator/TaskRange';
import ScheduleType from '@/containers/Schedule/CreateTemplate/TaskCreator/ScheduleType';
import { getCMSTemplateByDeviceId } from '@/apis/apiCollection';
import { fullWindowTemplateId, pldmTemplateId } from '@/containers/CMS/TemplateList/CONSTANT';
import { CircularProgress } from '@material-ui/core';

const ContentDisplayStatus = ({ companyId, deviceId, refreshRef, loading }) => {
  const [data, setData] = useState({})
  const { t, userLanguage } = useTranslation()

  const columns = [
    {
      data: "name",
      title: t({ defaultMessage: "模板名称" }),
      searchable: false,
    },
    {
      data: "deployStatus",
      title: t({ defaultMessage: "状态" }),
      searchable: false,
      createdCell: (td, data, row) => {
        const statusMap = {
          0: [t({ defaultMessage: "待部署" }), "#3491FA"],
          1: [t({ defaultMessage: "成功" }), "#00B42A"],
          2: [t({ defaultMessage: "失败" }), "#F53F3F"],
        }
        const status = statusMap[data]
        ReactRender(
          (
            <div style={{ color: status[1] }}>
              {status[0]}
            </div>
          ),
          td)
      }
    },
    {
      data: "contentTemplateTypeId",
      title: t({ defaultMessage: "类型" }),
      searchable: false,
      render: data => {
        switch (data) {
          case fullWindowTemplateId:
            return "Full Screen"
          case pldmTemplateId:
            return "PLDM"
          default:
            return ""
        }
      }
    },
    {
      data: "version",
      title: t({ defaultMessage: "版本" }),
      searchable: false,
      render: (data, _, row) => {
        return `${row.versionPrefix}${data}`
      },
    },
    {
      data: "name",
      title: t({ defaultMessage: "播放时段" }),
      orderable: false,
      createdCell: (td, data, row) => {
        if (row.contentTemplateTypeId !== fullWindowTemplateId) {
          ReactRender(<div>-</div>, td)
          return
        }
        const detail = JSON.parse(row.contentTemplateDetail)
        const taskRangeData = {
          json: {
            start_datetime: Number(row.effectBeginTime),
            end_datetime: Number(row.effectEndTime),
            run_times: row.effectType === 3 ? row.effectTimes : 0,
            end_type: row.effectType === 1 ? "forever" : row.effectType === 2 ? "datetime" : "times",
          }
        }
        const typeData = {
          schedule_type: detail.loopMode,
          json: {
            cycle_type: detail.loopMode === "weekly" ? "weekly_days" : detail.loopMode,
            cycle_value: detail.loopMode === "weekly" ? 1 : detail.loopDailyValue === "every_day" ? "every" : detail.loopDailyValue,
            cycle_days: detail.loopModeDays
          }
        }
        ReactRender(
          (
            <div style={{ textWrap: "wrap", minWidth: 130 }}>
              <div style={{ width: "fit-content" }}>
                <ScheduleTaskRange data={taskRangeData} />
              </div>
              <div style={{ width: "fit-content" }}>
                <ScheduleType data={typeData} />
              </div>
              <div style={{ width: "fit-content" }}>
                {(detail.executeTimeRangeInfo || []).map(v => `${v.executeBeginTime.hour.toString().padStart(2, '0')}:${v.executeBeginTime.minute.toString().padStart(2, '0')} - ${v.executeEndTime.hour.toString().padStart(2, '0')}:${v.executeEndTime.minute.toString().padStart(2, '0')}`).join(", ")}
              </div>
            </div>
          )
          , td
        );
      },
    },
    {
      data: "contentTemplateDetail",
      title: t({ defaultMessage: "播放状态" }),
      searchable: false,
      render: (data) => {
        if (!data) return '-'
        const detail = JSON.parse(data)
        if (detail.display === 1) return t({ defaultMessage: "播放" })
        return t({ defaultMessage: "暂停" })
      }
    },
    {
      data: "installationTime",
      title: t({ defaultMessage: "安装时间" }),
      searchable: false,
      render: (data, _, row) => {
        return moment(Number(data)).format("YYYY-MM-DD HH:mm")
      },
    },
  ]

  const handleRefresh = async () => {
    const res = await getCMSTemplateByDeviceId({ deviceId, companyId })
    await new Promise(resolve => setTimeout(resolve, 500));
    setData(res.contentTemplates)
  }

  if (refreshRef) refreshRef.current = handleRefresh

  useEffect(() => {
    if (companyId) handleRefresh()
  }, [deviceId, companyId])

  return (
    <div style={{ position: 'relative' }}>
      <DataTable
        columns={columns}
        data={data}
        // ref={ref}
        ordering={false}
        // scrollable
        // onLoaded={onLoaded}
        autoLoad
        showCheckAll={false}
        paging={false}
        options={{ serverSide: false, paging: false }}
      />
      {loading && <CircularProgress style={{ position: 'absolute', top: "calc(50% - 20px)", left: "calc(50% - 20px)", zIndex: 99999 }} />}
    </div>
  )
}

export default ContentDisplayStatus